import { Component, OnDestroy, OnInit, ViewEncapsulation } from "@angular/core";
import { DomSanitizer } from "@angular/platform-browser";
import { Subscription } from "rxjs/Subscription";
import { TextContentService } from "../../services/text-content/text-content.service";
import { WindowScrollService } from "../../services/window/window-scroll.service";
import { Link } from "../../ui-library/link/link.model";

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: "app-home",
  styleUrls: ["./home.view.component.scss"],
  templateUrl: "./home.view.component.html",
})
export class HomeComponent implements OnInit, OnDestroy {
  private link = new Link("Link", "link");
  private button = "Get More";
  private scrollSubscription: Subscription;
  private scrollVal: number;
  private introText: string;
  private biography: string;
  private biographyCTA: string;

  private animationsList = {
    biographyCta: false,
    biographyImg: false,
    secondSectionBottomDivider: false,
  };

  constructor(
    private sanitizer: DomSanitizer,
    private windowScrollService: WindowScrollService,
    private textContentService: TextContentService,
  ) { }

  public ngOnInit() {
    this.scrollSubscription = this.windowScrollService.scrollObservable
      .subscribe((scrolllY: number) => this.scrollVal = scrolllY);

    this.introText = this.textContentService.strings.introText;
    this.biography = this.textContentService.strings.biography;
    this.biographyCTA = this.textContentService.strings.biographyCTA;
  }

  public ngOnDestroy() {
    this.scrollSubscription.unsubscribe();
  }

  private isElementInViewport(evt: any, elementAnimationID: string) {
    if (evt.status) {
      this.animationsList[elementAnimationID] = true;
    }
  }

  private swanMutation() {
    const standarizedVal = Math.max(1, (this.scrollVal / 12));
    const style = `
      transform: scale(${Math.min(standarizedVal, 17)});
      fill: rgb(0, 0, ${Math.round(standarizedVal * 20)});
    `;
    return this.sanitizer.bypassSecurityTrustStyle(style);
  }
}



// WEBPACK FOOTER //
// ./src/app/views/home/home.view.component.ts